module.exports = __webpack_public_path__ + "img/wxznpz.bf8be30c.png";